// Fetches subscription plans (GET /subscription-plans) for the paywall popup.
import { useEffect, useState } from 'react';

const API_BASE_URL = `${process.env.REACT_APP_SWIPEY_BASE_URL}/api/v1`;
const API_KEY = process.env.REACT_APP_API_KEY;

// → { plans, isLoading, error }
export function useSubscriptionPlans() {
  const [plans, setPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE_URL}/subscription-plans`, {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY,
          },
        });
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data?.message || `HTTP error! status: ${res.status}`);
        }
        if (!cancelled) setPlans(Array.isArray(data) ? data : []);
      } catch (err) {
        if (!cancelled) {
          console.warn('[paywall-popup] subscription-plans fetch failed', err);
          setError(err);
          setPlans([]);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { plans, isLoading, error };
}
